/*
 * Cart reserve timer (display-only). Counts down a reservation window stored in
 * localStorage, resets on any cart activity, and empties the cart when it runs
 * out (returning the drawer to its empty state). Does not place a real
 * inventory hold.
 */
(function () {
  var KEY = 'poetic:cartReserveExpiry';

  // Re-running (e.g. a section reload in the theme editor) reuses the existing
  // instance instead of spinning up a second timer.
  if (window.__poeticReserve) { window.__poeticReserve.reload(); return; }

  var state = { interval: null, subscribed: false, expiring: false };

  function inEditor() { return !!(window.Shopify && window.Shopify.designMode); }
  function bar() { return document.querySelector('.cart-reserve'); }

  function minutes() {
    var b = bar();
    var m = b ? parseInt(b.getAttribute('data-reserve-minutes'), 10) : NaN;
    return (isFinite(m) && m > 0) ? m : 10;
  }

  function durationMs() { return minutes() * 60 * 1000; }

  function readExpiry() {
    var v = null;
    try { v = localStorage.getItem(KEY); } catch (e) {}
    var n = v ? parseInt(v, 10) : NaN;
    return isFinite(n) ? n : null;
  }

  function writeExpiry(ts) {
    try {
      if (ts == null) localStorage.removeItem(KEY);
      else localStorage.setItem(KEY, String(ts));
    } catch (e) {}
  }

  function fmt(ms) {
    if (ms < 0) ms = 0;
    var total = Math.round(ms / 1000);
    var m = Math.floor(total / 60);
    var s = total % 60;
    return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }

  function paint(ms) {
    var text = fmt(ms);
    var els = document.querySelectorAll('[data-reserve-time]');
    for (var i = 0; i < els.length; i++) els[i].textContent = text;
  }

  function hasItems() {
    // The reserve bar is only server-rendered when the cart is non-empty.
    return !!bar();
  }

  function startTicking() {
    if (state.interval) return;
    tick();
    state.interval = setInterval(tick, 1000);
  }

  function stopTicking() {
    if (state.interval) { clearInterval(state.interval); state.interval = null; }
  }

  function ensureStarted(reset) {
    if (!hasItems()) { writeExpiry(null); stopTicking(); return; }
    var now = Date.now();
    var exp = readExpiry();
    if (reset || exp == null || exp <= now) {
      exp = now + durationMs();
      writeExpiry(exp);
    }
    state.expiring = false;
    startTicking();
  }

  function tick() {
    if (!hasItems()) { stopTicking(); return; }
    var exp = readExpiry();
    var now = Date.now();
    if (exp == null) { ensureStarted(false); return; }
    var remaining = exp - now;
    if (remaining <= 0) { expire(); return; }
    paint(remaining);
  }

  function expire() {
    if (state.expiring) return;
    state.expiring = true;
    writeExpiry(null);
    stopTicking();

    // Clear the cart and let the drawer re-render into its empty state.
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
    })
      .then(function () { return refreshCart(); })
      .catch(function () {});
  }

  function refreshCart() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var url = root + '?sections=cart-drawer,cart-icon-bubble';
    return fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data['cart-drawer']) {
          var parsed = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
          var next = parsed.querySelector('#CartDrawer');
          var cur = document.querySelector('#CartDrawer');
          if (next && cur) cur.innerHTML = next.innerHTML;
        }
        if (data && data['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) {
            var pb = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
            var inner = pb.querySelector('.shopify-section');
            bubble.innerHTML = inner ? inner.innerHTML : bubble.innerHTML;
          }
        }
        var cd = document.querySelector('cart-drawer');
        if (cd) cd.classList.add('is-empty');
        if (typeof updateFreeShippingMessage === 'function') {
          try { updateFreeShippingMessage(); } catch (e) {}
        }
      });
  }

  function subscribeCart() {
    if (state.subscribed) return;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    state.subscribed = true;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var count = (event && event.cartData) ? event.cartData.item_count : undefined;
      if (count === 0) { writeExpiry(null); stopTicking(); paint(0); return; }
      // Any cart activity restarts the reservation window.
      state.expiring = false;
      writeExpiry(Date.now() + durationMs());
      startTicking();
    });
  }

  // In the theme editor, always restart from the configured duration so the
  // preview reflects setting changes (e.g. adjusting Reserve duration).
  function reload() {
    state.expiring = false;
    ensureStarted(inEditor());
  }

  window.__poeticReserve = { reload: reload };

  if (inEditor()) {
    document.addEventListener('shopify:section:load', reload);
    document.addEventListener('shopify:section:select', reload);
  }

  function init() {
    subscribeCart();
    ensureStarted(inEditor());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
